import config from "@/utils/Config";
import {get, post } from "@/utils/request";

export function getInstrList(params = {}) {
    return get(config.BASE_URL, config.getInstrList, params)
}

export function saveInstrInfo(params = {}, configParmas = {}) {
    return post(config.BASE_URL, config.saveInstrInfoUrl, params, configParmas)
}

export function getInstrAdminListByPage(params = {}) {
    return post(config.BASE_URL, config.getInstrAdminListByPageUrl, params)
}

export function delInstrInfo(params = { id: id }) {
    return post(config.BASE_URL, config.delInstrInfoUrl, params)
}



export function saveInstrType(params = {}) {
    return post(config.BASE_URL, config.saveInstrTypeUrl, params)
}

export function getInstrTypeList(params = {}) {
    return get(config.BASE_URL, config.getInstrTypeListUrl, params)
}

export function getInstrTypeAdminList(params = {}) {
    return post(config.BASE_URL, config.getInstrTypeListAdminUrl, params)
}

export function delInstrType(params = { id: id }) {
    return post(config.BASE_URL, config.delInstrTypeUrl, params)
}